module.exports = __webpack_public_path__ + "components/flag/static/square/so-4301013f40bd4e86b7872464a9376159.svg";